import { render, staticRenderFns } from "./consultationItem.vue?vue&type=template&id=2ff4a88e&scoped=true"
import script from "./consultationItem.vue?vue&type=script&lang=js"
export * from "./consultationItem.vue?vue&type=script&lang=js"
import style0 from "./consultationItem.vue?vue&type=style&index=0&id=2ff4a88e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff4a88e",
  null
  
)

export default component.exports